subscription studentDataloadProcessed($teamId: ID, $tz: String){
  studentDataloadProcessed(teamId: $teamId) {
    id
    status
    teacher {
      id
      email
      first
      last
      isCurrent
    }
    insertedAt(tz: $tz)
  }
}
